import SkeletonElement from "./SkeletonElement";

export default function ObjectHeaderSkeleton() {
  return (
    <div data-testid="object-header-skeleton" className="space-y-4 pt-8">
      <div className="flex items-center space-x-4">
        <SkeletonElement height="h-12" width="w-12" rounded="rounded-full" />
        <div className="flex-1 space-y-2 py-1">
          <SkeletonElement height="h-6" width="w-3/4" />
          <SkeletonElement height="h-4" width="w-1/2" />
        </div>
      </div>
    </div>
  );
}
